export default "/images/artist2.png?ac08ef65ef1f8b287840dd5c46ccc4f2";